import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarCheckpointFamilySchema } from '../schemas';

const grammarCheckpointHistoryItemSchema = z.object({
  level: z.string(),
  score: z.number().int().min(0).max(100),
  families: z.array(grammarCheckpointFamilySchema),
  createdAt: z.number().int(),
});

const listGrammarCheckpointHistoryV1DataSchemaDefinition = z.object({
  items: z.array(grammarCheckpointHistoryItemSchema),
});

export const listGrammarCheckpointHistoryV1DataSchema: typeof listGrammarCheckpointHistoryV1DataSchemaDefinition =
  listGrammarCheckpointHistoryV1DataSchemaDefinition;

export type IListGrammarCheckpointHistoryV1Data = z.infer<
  typeof listGrammarCheckpointHistoryV1DataSchema
>;

export const listGrammarCheckpointHistoryV1ResponseSchema: z.ZodSchema<
  IAPI<IListGrammarCheckpointHistoryV1Data>
> = createApiResponseSchema(listGrammarCheckpointHistoryV1DataSchema) as z.ZodSchema<
  IAPI<IListGrammarCheckpointHistoryV1Data>
>;

export type IListGrammarCheckpointHistoryV1Response = IAPI<IListGrammarCheckpointHistoryV1Data>;
